import React from "react";
import { IoClose } from "react-icons/io5";
import { CiShare1 } from "react-icons/ci";
import { useStateValue } from "../../../context/StateProvider.js";
import content from "../../../language/index.js";

const CookieSetting = ({ onUserChoice }) => {
  const [{ language }] = useStateValue();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div
        onClick={(e) => e.stopPropagation()}
        className=" bg-themeColor w-[90%] md:w-[70%] lg:w-[55%] xl:w-[40%] rounded-2xl shadow-2xl p-6 transform transition-all duration-300 scale-95 opacity-0 animate-modalEnter relative"
      >
        {/* Close Button */}
        <button
          className="absolute top-4 right-4 text-white hover:text-red-500 transition"
          onClick={() => onUserChoice("no")}
        >
          <IoClose className="text-xl font-bold" />
        </button>

        <div className="flex flex-col items-center">
          <h1 className="PoppinsRegular text-white text-center text-2xl">
            {content[language].cookieStting.head}
          </h1>
          <p className="PoppinsRegular mt-4 text-center text-sm text-white">
            {content[language].cookieStting.desc}
          </p>
          <div className="flex justify-between w-full lg:w-[90%] mx-auto mt-7">
            <div className="w-[48%] md:w-[46%]">
              <button
                className="bg-themegreen rounded-full text-white PoppinsRegular w-full py-3 text-sm md:text-base lg:text-lg"
                onClick={() => onUserChoice("yes")}
              >
                {content[language].cookieStting.accept}
              </button>
            </div>
            <div className="w-[48%] md:w-[46%]">
              <button
                className="bg-red-500 rounded-full text-white PoppinsRegular w-full py-3 text-base lg:text-lg"
                onClick={() => onUserChoice("no")}
              >
                {content[language].cookieStting.reject}
              </button>
            </div>
          </div>
        </div>

        {/* <div className="flex items-center mt-8">
          <label className="inline-flex items-center cursor-pointer relative pl-3">
            <input value={true} type="checkbox" className="sr-only peer" />
            <div className="relative w-11 h-6 bg-themeColor peer-focus:outline-none rounded-full peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-themeColor"></div>
          </label>
          <p className="PoppinsRegular ml-3 mr-2 text-sm">
            {content[language].cookieStting.terms}
          </p>
          <CiShare1 className="text-xl font-bold" />
        </div> */}

        {/* <div className="flex justify-end mr-1 mt-3 lg:mt-0">
          <p className="PoppinsRegular underline cursor-pointer text-base">
            {content[language].cookieStting.save}
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default CookieSetting;
